// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"76f80c1a","453":"66d8bf95"}[chunkId] + ".chunk.js");